import { makeStyles, Theme } from "@material-ui/core";
export const useArticlesStyles = makeStyles((theme: Theme) => ({
  container: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  researchBlockCard: {
    border: "1px solid blue",
  },
}));
